const JMJSolicitation = [
    {
        id: "MEMBERSHIP_INCLUSION_DEPENDENTS",
        name: "Adesão e inclusão dependentes",
        category: 260,
        subCategory: 601,
        manifestation: 946
    },
    {
        id: "EXCLUSION_DEPENDENTS",
        name: "Cancelamento e exclusão de dependentes",
        category: 260,
        subCategory: 601,
        manifestation: 947
    },
];
export default JMJSolicitation;